enum CreditCodesEnum {
  CreditToWatchCvVideo = 'CRD_USE_CREDIT_TO_WATCH_CV_VIDEO',
  CreditToUnlockContact = 'CRD_USE_CREDIT_TO_UNLOCK_CONTACT',
  CostToWatchCvVideo = 'CRD_COST_TO_WATCH_CV_VIDEO',
  CostToUnlockContact = 'CRD_COST_TO_UNLOCK_CONTACT',
  TimeoutDay = 'CRD_TIMEOUT_DAY',
  DefaultThreshold = 'CRD_DEFAULT_THRESHOLD',
  NotificationToShareTopUpCreated = 'CRD_NOTIFICATION_TO_SHARE_CREATED_TOP_UP',
  EmailToShareTopUpCreated = 'CRD_EMAIL_TO_SHARE_CREATED_TOP_UP',
  NotificationShareDone = 'CRD_SHARE_DONE',
  NotificationThreshold = 'CRD_NOTIFICATION_THRESHOLD',
  EmailThreshold = 'CRD_EMAIL_THRESHOLD',
}

export default CreditCodesEnum;
